import script from "./SignUpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpPage.vue?vue&type=script&setup=true&lang=js"

import "./SignUpPage.vue?vue&type=style&index=0&id=96e3d518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96e3d518"]])

export default __exports__